import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router'

require('../css/login.css')

@observer(['globals', 'users'])
export default class Login extends Component {

  constructor(props) {
    super(props)

    this.state = {
      message: ''
    }

    document.body.className = 'login'
    document.body.style.backgroundColor = '#eee'
  }

  componentWillMount() {
      // Load users
      this.props.users.loadAllUsers()
  }

  handleLoginClick(e) {
    const username = document.getElementById('username').value
    const password = document.getElementById('password').value

    this.props.users.loginWithUsernamePassword(username, password, this.props.globals, () => {
      this.setState({
        message: 'Invalid username or password!'
      })
    })
  }

  handleOnKeyUp(e) {
    if (e.key == 'Enter') {
      this.handleLoginClick(e)
    }
  }

  render() {

    return (
      <div className="login">
        <div>
          <div className="login_wrapper">
            <div className="animate form login_form">
              <section className="login_content">
              <img src="/images/logo-white.png" /><br />
                <form>
                  <h1>Login</h1>
                  <div>
                    <input id="username" style={
                      {
                        height: "34px",
                        paddingLeft: "12px",
                        paddingRight: "12px",
                        paddingTop: "6px",
                        paddingBottom: "6px",
                        backgroundColor: "#FFF"
                      }
                    } type="text" className="form-control" placeholder="Username" required=""  onKeyUp={ this.handleOnKeyUp.bind(this) } />
                  </div>
                  <div>
                    <input id="password" style={
                      {
                        height: "34px",
                        paddingLeft: "12px",
                        paddingRight: "12px",
                        paddingTop: "6px",
                        paddingBottom: "6px"
                      }
                    } type="password" className="form-control" placeholder="Password" required="" onKeyUp={ this.handleOnKeyUp.bind(this) } />
                  </div>
                  <div>
                    <Button onClick={ this.handleLoginClick.bind(this) }>Log in</Button>
                    <Link to="/forgotpassword">Forgot Password</Link>
                    { /* <a className="reset_pass" href="#">Lost your password?</a> */ }
                  </div>
                  <div className="clearfix"></div>
                  <div className="separator">
                    <span className="alert-message">{ this.state.message }</span>
                    <div className="clearfix"></div>
                    <div>
                      <h1>GPS Leaders CRM</h1>
                      <p>©2017 All Rights Reserved. This is a GPS Leaders product.</p>
                    </div>
                  </div>
                </form>
              </section>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/login.js